module.exports = __webpack_public_path__ + "img/creditcard_ru.60058692.svg";